import Footer from "app/pages/.shared/Footer/Footer";

const BrandFooter = props => <Footer {...props} />;
export default BrandFooter;
